import { useAtomValue } from 'jotai';

import { selectTeethAtom } from '../../../../patientList/atoms';
import { modelsTogglesAtom } from '../../../findingSidebar/atoms';
import { useGetModelFeatureFlags } from '../../../utils';
import { hiddenAnnotationsAtom, selectedFindingsAtom } from '../../atoms';

/**
 * Hook to determine if findings should be hidden based on various conditions
 * This logic is shared between PatientDownloadableLoader and PatientDownloadableHandler
 */
export const useFindingsHidden = () => {
  const enabledFindingsTypes = useAtomValue(modelsTogglesAtom);
  const singleFinding = useAtomValue(selectedFindingsAtom);
  const selectedTeeth = useAtomValue(selectTeethAtom);
  const hiddenAnnotations = useAtomValue(hiddenAnnotationsAtom);
  const { isPrlEnabled, isRblEnabled, isCalculusEnabled } =
    useGetModelFeatureFlags();

  const isPrlDisabled = isPrlEnabled
    ? !enabledFindingsTypes.periapical_radiolucency
    : false;
  const isRblDisabled = isRblEnabled
    ? !enabledFindingsTypes.radiographic_boneloss
    : false;
  const isCalculusDisabled = isCalculusEnabled
    ? !enabledFindingsTypes.calculus
    : false;

  const hideFindings =
    isPrlDisabled ||
    isRblDisabled ||
    isCalculusDisabled ||
    !enabledFindingsTypes.caries ||
    !!singleFinding ||
    selectedTeeth.length > 0 ||
    (hiddenAnnotations && hiddenAnnotations.length > 0);

  return hideFindings;
};
